import { useLoaderData, useOutletContext } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    Collapse,
    Divider,
    FormControlLabel,
    Link,
    Paper,
    Typography,
    Unstable_Grid2 as Grid,
} from '@mui/material';
import { getTemporaryToken, signOutSession } from '@/services/auth.service';
import { getTemporaryUserInfo } from '@/services/open-mall.service';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'react-i18next';

export interface UnitedTermsPropType {
    // hookForm: UseFormReturn<FieldValues, any>
    stateValue: {
        isAgreePolicy: boolean;
        agreePolicy: boolean;
        agreeSalesRules: boolean;
        agreePrivateRules: boolean;
        isAdult: boolean;
        agreeMarketing: boolean;
    };
    isAllAgree: boolean;
    setState: {
        setIsAgreePolicy: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreePolicy: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreeSalesRules: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreePrivateRules: React.Dispatch<React.SetStateAction<boolean>>;
        setIsAdult: React.Dispatch<React.SetStateAction<boolean>>;
        setAgreeMarketing: React.Dispatch<React.SetStateAction<boolean>>;
    };
    handleAllAgree: (checked: boolean) => void;
}

const UnitedTerms = (props: UnitedTermsPropType) => {
    const { t } = useTranslation();
    const {
        handleAllAgree,
        isAllAgree,
        setState: {
            setAgreePolicy,
            setIsAgreePolicy,
            setAgreePrivateRules,
            setAgreeSalesRules,
            setIsAdult,
            setAgreeMarketing,
        },
        stateValue: { agreePolicy, isAgreePolicy, agreePrivateRules, agreeSalesRules, isAdult, agreeMarketing },
    } = props;
    const [termsOpen, setTermsOpen] = useState<boolean>(false);
    return (
        <Box
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    justifyContent: 'center',
                }}
            >
                <Grid container rowSpacing={1}>
                    <Grid xs={12} className="flex justify-between">
                        <FormControlLabel
                            control={<Checkbox />}
                            label={t('auth.agreeAll')}
                            checked={isAllAgree}
                            onChange={(event, checked) => {
                                handleAllAgree(checked);
                            }}
                        />
                        <Button
                            size="small"
                            onClick={() => {
                                setTermsOpen((prev) => !prev);
                            }}
                        >
                            {termsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            {t('auth.viewItems')}
                        </Button>
                    </Grid>
                    <Grid xs={12}>
                        <Divider />
                    </Grid>
                    <Collapse in={termsOpen} className="w-full">
                        <Grid xs={12}>
                            <ul>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.flowingTermsAndPolicy')}
                                            checked={isAgreePolicy}
                                            onChange={(ev, checked) => {
                                                setIsAgreePolicy(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                        <Typography color={'error'} component={'span'}>
                                            ({t('common.required')})
                                        </Typography>
                                    </div>
                                    <Button
                                        size={'small'}
                                        href={'https://terms.flowing.tel/'}
                                        target={'_blank'}
                                        onClick={() => {
                                            setIsAgreePolicy(true);
                                        }}
                                    >
                                        {t('auth.viewAll')}
                                    </Button>
                                </li>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.serviceTerms')}
                                            checked={agreePolicy}
                                            onChange={(ev, checked) => {
                                                setAgreePolicy(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                        <Typography color={'error'} component={'span'}>
                                            ({t('common.required')})
                                        </Typography>
                                    </div>
                                    <Button
                                        size={'small'}
                                        href={'https://terms.flowing.tel/terms.html'}
                                        target={'_blank'}
                                        onClick={() => {
                                            setAgreePolicy(true);
                                        }}
                                    >
                                        {t('auth.viewAll')}
                                    </Button>
                                </li>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.salesPolicyAgreement')}
                                            checked={agreeSalesRules}
                                            onChange={(ev, checked) => {
                                                setAgreeSalesRules(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                        <Typography color={'error'} component={'span'}>
                                            ({t('common.required')})
                                        </Typography>
                                    </div>
                                    <Button
                                        size={'small'}
                                        href={'https://terms.flowing.tel/'}
                                        target={'_blank'}
                                        onClick={() => {
                                            setAgreeSalesRules(true);
                                        }}
                                    >
                                        {t('auth.viewAll')}
                                    </Button>
                                </li>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.privacyPolicyAgreement')}
                                            checked={agreePrivateRules}
                                            onChange={(ev, checked) => {
                                                setAgreePrivateRules(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                        <Typography color={'error'} component={'span'}>
                                            ({t('common.required')})
                                        </Typography>
                                    </div>
                                    <Button
                                        size={'small'}
                                        href={'https://terms.flowing.tel/privacy.html'}
                                        target={'_blank'}
                                        onClick={() => {
                                            setAgreePrivateRules(true);
                                        }}
                                    >
                                        {t('auth.viewAll')}
                                    </Button>
                                </li>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.ageVerification')}
                                            checked={isAdult}
                                            onChange={(ev, checked) => {
                                                setIsAdult(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                        <Typography color={'error'} component={'span'}>
                                            ({t('common.required')})
                                        </Typography>
                                    </div>
                                </li>
                                <li className={'flex justify-between items-center'}>
                                    <div className={'flex flex-wrap items-center'}>
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={t('auth.marketingAgreement')}
                                            checked={agreeMarketing}
                                            onChange={(ev, checked) => {
                                                setAgreeMarketing(checked);
                                            }}
                                            sx={{ mr: 0 }}
                                        />
                                    </div>
                                </li>
                            </ul>
                        </Grid>
                    </Collapse>
                </Grid>
            </Box>

            {/* <Grid container>
                <Grid xs={12}>
                    <Button variant={'contained'} disabled={!(agreePolicy && agreeSalesRules && agreePrivateRules && isAdult)}
                            href={`../form?marketing=${agreeMarketing}`}
                            size={'large'} fullWidth>동의 완료</Button>
                </Grid>
            </Grid> */}
        </Box>
    );
};
export default UnitedTerms;
